/*eslint-disable */
import ActivitiesTable from './ActivitiesTable';

export default ActivitiesTable;
